import * as yup from 'yup'

const validationSchema = (t) =>
  yup.object().shape({
    name: yup.string().required(t('hospital.form.error.name')),
    location: yup.string().required(t('hospital.form.error.location')),
    availableTime: yup
      .string()
      .required(t('hospital.form.error.availableTime')),
    telemedUrl: yup
      .string()
      .required(t('hospital.form.error.telemedUrl'))
      .url(t('hospital.form.error.telemedUrlInvalid')),
  })

export default validationSchema
